const LinkedIn = {
  enable() {},
  wait() {
    return true;
  },
  init() {},
  landing() {},
  paso1() {},
  paso2() {},
  paso3() {},
  paso4() {},
  gracias() {
    window._linkedin_data_partner_id = "67020";
    (function() {
      let s = document.getElementsByTagName("script")[0];
      let b = document.createElement("script");
      b.type = "text/javascript";
      b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      s.parentNode.insertBefore(b, s);
    })();
  },
  mensaje() {}
};

export default LinkedIn;
